import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import axios from '../../redux/axios';

const initialState = {
  department: {},
  isFetching: false,
  isSuccess: false,
  isUpdated:false,
  isError: false,
  errorMessage: '',
};

export const getDepartment = createAsyncThunk(
  'user/viewdepartments',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.get('/api/department/'+udata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const viewDepartmentSlice = createSlice({
  name: 'viewdepartment',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateDepartment: (state, {payload}) => { 
       state.department = {};
       state.isError = false;
       state.isSuccess = false;
       state.isUpdated = false;
       state.errorMessage = '';
    },
    updateDepartment: (state, {payload}) => {  
      if(payload.success==false)  state.isError = true;
      else state.isError = false;
      if(payload.success) state.isUpdated = true;
      if(payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';
   },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
        [getDepartment.fulfilled]: (state, { payload }) => {
     
          state.department = payload.data;
          state.isFetching = false;
          state.isSuccess = true;
          return state;
        },
        [getDepartment.pending]: (state) => {
          state.isFetching = true;
        },
        [getDepartment.rejected]: (state, { payload }) => {
          state.isFetching = false;
          state.isError = true;
          if(payload){
            state.errorMessage = payload.message;
          }
          else{
            state.errorMessage = 'Internal error';
          }
        }
    },
});

 export const {clearStateDepartment,updateDepartment} = viewDepartmentSlice.actions;

 export function clearState() {
  
  return async (dispatch) => {
    dispatch(clearStateDepartment());
  }
}

export const updateDepartmentAsyn = (udata) => async (dispatch, getState) => {
  try {
  const { auth } = getState()
   let tokenStr = auth.user.token;
   const response = await axios.patch('/api/department',udata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });


   let data = response.data;
   dispatch(updateDepartment(data));
  } catch (error) {
    dispatch(updateDepartment(error.response.data));
  }
};

// export const updateDepartmentAsyn = (userData) => async (dispatch, getState) => {
//   const { auth } = getState()
//   let token = auth.user.token;
//   return axios
//     .patch("/api/department", userData, {
//       headers: {
//         'Authorization': 'Bearer '+token
//       }
//     })
//     .then((response) => {
//       let res = response.data;
//       if (res.response==true) {
//         dispatch(updateDepartment(res));
//       }
     
//       return res;
//     });
// };

export const getDepartmentSelector = (state) => state.viewdepartment;

export default viewDepartmentSlice.reducer;
